import request from '../../common/services/proxy.service'

// 登录方法
export function login(data) {
  return request({
    // url: '/jingutrust-permisson/login',
    url: 'login',
    method: 'post',
    data: data
  })
}
export function logOut(data) {
  return request({
    url: 'logOut',
    method: 'post',
    data: data
  })
}
export function getAuthority(data){
  return request({
    url: 'base/user/get-user-authority',
    method: 'post',
    data: data
  })
}
//远程数据字典
export function Remotedictionary(data) {
    return request({
      url: '/base/dict/query-batch-dict-type',
      method: 'post',
      data: data
    })
  }